/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import { EFFORT_WORKFLOW } from '../resources/endPoint';

export const getEffortData = (token) => {
  return {
    url: EFFORT_WORKFLOW,
    method: 'get',
    headers: { 'content-type': 'application/json', token: token },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const editEffortData = (newDetails) => {
  
  let url = `${EFFORT_WORKFLOW}?id=${JSON.parse(newDetails.id)}`;

  return {
    url: url,
    method: 'put',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
    payload: newDetails,
  };
};

export const addEffortData = (newDetails) => {
  return {
    url: EFFORT_WORKFLOW,
    method: 'post',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
    payload: newDetails,
  };
};

export const deleteEffortData = (newDetails) => {
  let url = `${EFFORT_WORKFLOW}?id=${JSON.parse(newDetails.id)}`;

  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
    payload: newDetails,
  };
};
